<template>
  <div>
    <!-- 遮罩层 -->
    <transition name="fade">
      <div
        class="menu-overlay"
        v-show="isOpen"
        @click="closeMenu"
      ></div>
    </transition>

    <!-- 菜单面板 -->
    <transition name="slide">
      <div
        ref="menuPanel"
        class="menu-panel"
        v-show="isOpen"
        @mouseleave="onMenuLeave"
      >
        <!-- 顶部导航 -->
        <nav class="menu-top-nav font-apercu-medium">
          <a
            href="#"
            class="menu-nav-link"
            :class="{ active: currentSection === 'Collection' }"
            @click.prevent="switchSection('Collection')"
          >
            Collection
          </a>
          <a
            href="#"
            class="menu-nav-link"
            :class="{ active: currentSection === 'Info' }"
            @click.prevent="switchSection('Info')"
          >
            Info
          </a>
          <a
            href="#"
            class="menu-nav-link"
            :class="{ active: currentSection === 'Projects' }"
            @click.prevent="switchSection('Projects')"
          >
            HAHA!
          </a>
        </nav>

        <!-- 菜单内容区域 -->
        <div class="menu-content">
          <!-- Collection 内容 -->
          <div v-if="currentSection === 'Collection'" class="menu-section">
            <div class="category-section" v-for="block in collectionBlocks" :key="block.title">
              <div class="category-header">
                <h2
                  class="category-title"
                  style="cursor: pointer;"
                  @click="goToCategoryByBlock(block)"
                >
                  {{ block.title }}
                </h2>
                <a
                  v-if="block.title === 'TABLES'"
                  href="#"
                  class="view-all"
                  @click.prevent="onViewAllClick('table')"
                >
                  VIEW ALL
                </a>
              </div>
              <ul class="category-list">
                <li v-for="item in block.items" :key="item.key">
                  <a
                    href="#"
                    class="category-item"
                    @mouseenter="onItemEnter(item, block.section)"
                    @mouseleave="onItemLeave"
                    @click.prevent="onItemClick(item, block.section)"
                  >
                    {{ item.label }}
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!-- Info 内容 -->
          <div v-if="currentSection === 'Info'" class="menu-section">
            <div class="info-section" v-for="block in infoBlocks" :key="block.title">
              <div class="info-header">
                <h2 class="section-title">{{ block.title }}</h2>
              </div>
              <ul class="info-list" v-if="block.items && block.items.length">
                <li v-for="item in block.items" :key="item.key">
                  <a
                    href="#"
                    class="info-item"
                    @mouseenter="onItemEnter(item, block.section)"
                    @mouseleave="onItemLeave"
                    @click.prevent="onItemClick(item, block.section)"
                  >
                    {{ item.label }}
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <!-- Projects 内容 -->
          <div v-if="currentSection === 'Projects'" class="menu-section">
            <div class="projects-section">
              <a
                href="#"
                class="view-all-link"
                @mouseenter="onItemEnter({ key: 'all-projects', label: 'All Projects' }, 'projects')"
                @mouseleave="onItemLeave"
                @click.prevent="onItemClick({ key: 'all-projects', label: 'All Projects' }, 'projects')"
              >
                denHolm United
              </a>
            </div>
          </div>
        </div>

        <!-- 底部链接 -->
        <div class="menu-bottom-links">
          <a
            href="#"
            class="menu-link-bottom"
            @click.prevent="onBottomLinkClick('login')"
          >
            Login
          </a>
          <a
            href="#"
            class="menu-link-bottom"
            @click.prevent="onBottomLinkClick('subscribe')"
          >
            Subscribe
          </a>
        </div>
      </div>
    </transition>

    <!-- ★ 右侧内容区域 -->
    <transition name="drawer-slide" :duration="{ enter: 800, leave: 0 }">
      <div
        class="right-content-area"
        :class="{ 'is-collapsed': isContentCollapsed }"
        :style="{ left: menuPanelWidth }"
        v-if="isOpen && currentHeroImage"
        key="right-content"
      >
        <div class="right-content-inner">
          <img
            :key="currentHeroKey"
            v-if="currentHeroImage"
            :src="currentHeroImage"
            :alt="currentHeroTitle"
            class="hero-image"
          />
          <div class="hero-title" v-if="currentHeroTitle" :key="currentHeroKey + '-title'">
            {{ currentHeroTitle }}
          </div>
        </div>
      </div>
    </transition>

    <!-- Top Right Icons -->
    <div class="menu-top-right-icons" v-if="isOpen">
      <button class="icon-btn" @click.stop="openEnquiry">
        <img src="../assets/icon/logo.png" alt="search" class="icon-img" />
      </button>
      <button class="icon-btn" @click.stop="openEnquiry">
        <img src="../assets/icon/product.png" alt="search" class="icon-img" />
      </button>
      <button class="icon-btn" @click.stop="toggleSearch">
        <img src="../assets/icon/search.png" alt="search" class="icon-img" style="width: 15rem;" />
      </button>
    </div>
  </div>
</template>

<script>
import { getCategoryList } from '@/api/product'

const prod1 = require('@/assets/Group 1-1.png')
const prod2 = require('@/assets/Group 1-2.png')
const prod3 = require('@/assets/Group 1-3.png')
const prod4 = require('@/assets/Group 1-4.png')

export default {
  name: 'Menu',
  props: {
    isOpen: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      currentSection: 'Collection',
      hoverTimer: null,
      animationTimer: null,
      isContentCollapsed: false,
      isFirstHover: true,
      currentHeroKey: null,
      menuPanelWidth: '0rem',
      currentHeroImage: null,
      currentHeroTitle: '',
      collectionBlocks: [
        {
          title: 'TABLE',
          section: 'collection',
          categoryId: null,
          items: [
            { key: 'entry-table', label: 'Entry Table' },
            { key: 'console-table', label: 'Console Table' },
            { key: 'coffee-table', label: 'Coffee Table' },
            { key: 'side-table', label: 'Side Table' }
          ]
        },
        {
          title: 'SEATING',
          section: 'collection',
          categoryId: null,
          items: [
            { key: 'chair', label: 'Chair' },
            { key: 'stool', label: 'Stool' }
          ]
        },
        {
          title: 'ACCESSORIES',
          section: 'collection',
          categoryId: null,
          items: [
            { key: 'planter', label: 'Planter' },
            { key: 'lighting', label: 'Lighting' },
            { key: 'mirror', label: 'Mirror' },
            { key: 'hardware', label: 'Hardware' },
            { key: 'decor', label: 'Decor' }
          ]
        }
      ],
      infoBlocks: [
        {
          title: 'ABOUT',
          section: 'info',
          items: [
            { key: 'About', label: 'About Us', CategoryImage: require('@/assets/_DSC0544 2 3.jpg') },
            { key: 'Founder', label: 'Founder', CategoryImage: require('@/assets/_DSC0544 2 4.jpg') }
          ]
        },
        {
          title: 'Contact',
          section: 'info',
          items: [
            { key: 'Contact', label: 'Contact', CategoryImage: require('@/assets/renwu.jpg') }
          ]
        }
      ],
      heroImages: {
        'collection-entry-table': require('../assets/_DSC0544 2 2.png'),
        'collection-console-table': require('../assets/Group 1.png'),
        'collection-coffee-table': require('../assets/Group 1-1.png'),
        'collection-side-table': require('../assets/Group 1-2.png'),
        'collection-chair': require('../assets/_DSC0544 2 3.png'),
        'collection-stool': require('../assets/_DSC0544 2 3-1.png'),
        'collection-planter': require('../assets/_DSC0544 2 4.jpg'),
        'collection-lighting': require('../assets/_DSC0544 2 3.png'),
        'collection-hardware': require('../assets/_DSC0544 2 4.jpg'),
        'collection-decor': require('../assets/_DSC0544 2 3.png'),
        'info-about-us': require('../assets/_DSC0544 2 3.jpg'),
        'info-founder': require('../assets/_DSC0544 2 4.jpg'),
        'projects-all-projects': require('../assets/uni.png'),
        'collection-default': require('../assets/Group 1-1.png'),
        'info-default': require('../assets/_DSC0544 2 4.jpg'),
        'projects-default': require('../assets/_DSC0544 2 3.png'),
        'default': require('../assets/home_bg.jpg')
      }
    }
  },
  computed: {
    currentOpenComponent() {
      if (this.isLoginOpen) return 'login'
      if (this.isUserInfoOpen) return 'userInfo'
      if (this.isEnquiryOpen) return 'enquiry'
      if (this.showSearch) return 'search'
      return null
    }
  },
  watch: {
    isOpen(newVal) {
      if (newVal) {
        // ★ 菜单打开：发送事件并锁定 body 滚动
        this.$root.$emit('menu-opened')
        document.body.style.overflow = 'hidden'

        this.currentSection = 'Collection'
        this.emitHero({ key: 'collection-default', title: '' })
        this.isContentCollapsed = true
        this.isFirstHover = true
        this.fetchCollectionBlocks()
        this.$nextTick(() => {
          this.updateMenuPanelWidth()
        })
      } else {
        // ★ 菜单关闭：发送事件并恢复 body 滚动
        this.$root.$emit('menu-closed')
        document.body.style.overflow = ''

        this.currentHeroImage = null
        this.currentHeroTitle = ''
        this.currentHeroKey = null
        this.isContentCollapsed = true
        this.menuPanelWidth = '0rem'
      }
    }
  },
  mounted() {
    window.addEventListener('resize', this.updateMenuPanelWidth)
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.updateMenuPanelWidth)
  },
  methods: {
    closeMenu() {
      this.$emit('close')
    },
    switchSection(section) {
      this.currentSection = section
      const defaults = {
        Collection: { key: 'collection-default', title: '' },
        Info: { key: 'info-default', title: '' },
        Projects: { key: 'projects-default', title: '' }
      }
      this.emitHero(defaults[section] || { key: 'default', title: '' })
      if (section === 'Collection' && this.isOpen) {
        this.fetchCollectionBlocks()
      }
    },
    normalizeCategoryKey(value) {
      return String(value || '')
        .trim()
        .toLowerCase()
        .replace(/[^a-z0-9\s-]/g, '')
        .replace(/\s+/g, '-')
    },
    async fetchCollectionBlocks() {
      if (this.currentSection !== 'Collection') return
      try {
        const response = await getCategoryList()
        const list = Array.isArray(response)
          ? response
          : response && Array.isArray(response.result)
          ? response.result
          : []
        if (!list.length) return
        this.collectionBlocks = list.map((block) => {
          const items = Array.isArray(block.Items) ? block.Items : []
          return {
            title: block.CategoryName,
            section: 'collection',
            categoryId: block.CategoryID || null,
            items: items.map((item) => ({
              key: this.normalizeCategoryKey(item.CategoryName),
              label: item.CategoryName,
              CategoryImage: item.CategoryImage,
              CategoryID: item.CategoryID
            }))
          }
        })
      } catch (error) {
        console.error('Failed to load collection categories:', error)
      }
    },
    onItemClick(item, section) {
      const key = item.key
      if (section === 'projects' && key === 'all-projects') {
        window.open('https://www.instagram.com/den_holmunited/', '_blank')
        this.closeMenu()
        return
      }
      const routePages = ['About', 'Contact', 'Founder']
      if (routePages.includes(key)) {
        this.$router.push({ name: key })
        this.closeMenu()
      } else {
        this.handleCollectionItemClick(item, section)
      }
    },
    handleCollectionItemClick(item, section) {
      const categoryId = item.CategoryID || item.categoryId || null
      switch (section) {
        case 'collection':
          this.$router.push({
            name: 'ProductIndex',
            query: categoryId ? { CategoryID: String(categoryId) } : {}
          })
          break
        case 'info':
          console.log('跳转到 info 页面:', item.key)
          break
        case 'projects':
          this.$router.push({ name: 'Projects' })
          break
        default:
          console.log('跳转到:', item.key, section)
          break
      }
      this.closeMenu()
    },
    goToCategoryByBlock(block) {
      if (!block) return
      if (block.title === 'denHolm United') {
        window.open('https://www.denholm-united.com', '_blank')
        this.closeMenu()
        return
      }
      const categoryId = block.categoryId
      if (categoryId) {
        this.$router.push({
          name: 'ProductIndex',
          query: { CategoryID: String(categoryId) }
        })
        this.closeMenu()
      } else {
        console.warn('No categoryId for block:', block.title)
      }
    },
    onItemEnter(item, section) {
		 if (section === 'projects') {
		    return
		  }
      const width = this.$refs.menuPanel.offsetWidth
      this.menuPanelWidth = `${width}rem`
      if (this.hoverTimer) clearTimeout(this.hoverTimer)
      this.hoverTimer = setTimeout(() => {
        const newKey = `${section}-${item.key}`
        if (this.currentHeroKey === newKey && !this.isContentCollapsed) return
        if (this.isFirstHover) {
          this.updateHeroImage({
            key: newKey,
            title: item.label,
            image: item.CategoryImage
          })
          this.isContentCollapsed = false
          this.isFirstHover = false
          return
        }
        this.isContentCollapsed = true
        if (this.animationTimer) clearTimeout(this.animationTimer)
        this.animationTimer = setTimeout(() => {
          this.updateHeroImage({
            key: newKey,
            title: item.label,
            image: item.CategoryImage
          })
          this.isContentCollapsed = false
          this.animationTimer = null
        }, 600)
      }, 0)
    },
    onMenuLeave() {
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer)
        this.hoverTimer = null
      }
      if (this.animationTimer) {
        clearTimeout(this.animationTimer)
        this.animationTimer = null
      }
      this.isContentCollapsed = true
      this.isFirstHover = true
    },
    onItemLeave() {
      if (this.hoverTimer) {
        clearTimeout(this.hoverTimer)
        this.hoverTimer = null
      }
      this.isContentCollapsed = true
    },
    updateHeroImage(payload) {
      const { key, title, image } = payload || {}
      if (image) {
        this.currentHeroImage = image
        this.currentHeroTitle = title
        this.currentHeroKey = key || null
      } else if (key && this.heroImages[key]) {
        this.currentHeroImage = this.heroImages[key]
        this.currentHeroTitle = title
        this.currentHeroKey = key
      } else {
        const defaultKey = this.currentSection.toLowerCase() + '-default'
        this.currentHeroImage = this.heroImages[defaultKey] || this.heroImages.default
        this.currentHeroTitle = title || ''
        this.currentHeroKey = this.heroImages[defaultKey] ? defaultKey : 'default'
      }
      this.emitHero(payload)
    },
    resetHero() {
      const defaultKey = this.currentSection.toLowerCase() + '-default'
      this.currentHeroImage = this.heroImages[defaultKey] || this.heroImages.default
      this.currentHeroTitle = ''
      this.currentHeroKey = this.heroImages[defaultKey] ? defaultKey : 'default'
      this.emitHero({ key: defaultKey, title: '' })
    },
    emitHero(payload) {
      this.$emit('hero-change', payload || { key: 'default', title: '' })
    },
    updateMenuPanelWidth() {
      if (this.$refs.menuPanel && this.isOpen) {
        const width = this.$refs.menuPanel.offsetWidth
        this.menuPanelWidth = `${width}rem`
      }
    },
    onViewAllClick(type) {
      switch (type) {
        case 'table':
          this.$router.push({
            name: 'ProductIndex',
            query: { CategoryID: 0 }
          })
          break
        case 'about':
          this.$router.push({ name: 'About' })
          break
        default:
          this.$router.push({ name: 'ViewAll', params: { type } })
      }
      this.closeMenu()
    },
    onBottomLinkClick(type) {
      if (type === 'login') {
        this.$emit('toggle-login')
        return
      }
      if (type === 'subscribe') {
        this.$emit('toggle-subscribe')
        this.closeMenu()
        return
      }
      const linkMap = { login: '/login' }
      if (linkMap[type]) {
        this.$router.push(linkMap[type])
        this.closeMenu()
      }
    },
    closeAllComponents() {
      this.isLoginOpen = false
      this.isUserInfoOpen = false
      this.isEnquiryOpen = false
      this.showSearch = false
      this.searchQuery = ''
      this.showSearchResult = false
      return Promise.resolve()
    },
    async openLogin() {
      if (this.isAnimating) return
      const hadOpen = !!this.currentOpenComponent
      if (hadOpen) {
        this.isAnimating = true
        await this.closeAllComponents()
      }
      this.isLoginOpen = true
      if (hadOpen) {
        this.isAnimating = false
      }
    },
    closeLogin() {
      this.isLoginOpen = false
    },
    async openUserInfo() {
      this.$emit('toggle-user-info')
    },
    async openEnquiry() {
      this.$emit('toggle-enquiry')
    },
    switchToMenu() {
      this.closeLogin()
    },
    async toggleSearch() {
      this.$emit('toggle-search')
    },
    handleInput() {
      this.showSearchResult = false
      this.searchConfirmed = false
    },
    performSearch() {
      if (this.searchQuery.trim()) {
        this.showSearchResult = true
        this.searchConfirmed = true
      }
    },
    handleBlur() {
      this.showSearchResult = this.searchQuery !== ''
    },
    handleScroll(e) {
      if (!this.showSearchResult || this.isLoadingMore) return
      const { scrollTop, clientHeight, scrollHeight } = e.target
      if (scrollHeight - scrollTop - clientHeight < 100) {
        this.loadMoreResults()
      }
    },
    loadMoreResults() {
      this.isLoadingMore = true
      setTimeout(() => {
        const moreProducts = [
          { name: 'Product ' + (this.searchResults.length + 1), image: require('@/assets/Group 1-1.png') },
          { name: 'Product ' + (this.searchResults.length + 2), image: require('@/assets/Group 1-2.png') },
          { name: 'Product ' + (this.searchResults.length + 3), image: require('@/assets/Group 1-3.png') },
          { name: 'Product ' + (this.searchResults.length + 4), image: require('@/assets/Group 1-4.png') }
        ]
        this.searchResults = [...this.searchResults, ...moreProducts]
        this.isLoadingMore = false
      }, 1500)
    }
  }
}
</script>

<style scoped>
.icon-img {
  width: 14rem;
  height: 17rem;
}
.menu-overlay {
  position: fixed;
  top: 0;
  left: 0%;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.2);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  z-index: 998;
  max-width: 100%;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.8s ease;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.info-item:hover {
  color: #000;
  font-family: 'BespokeSerif-Italic', sans-serif !important;
  font-weight: 400 !important;
}
@media (max-width: 1024px) {
  .menu-overlay {
    left: 40%;
    max-width: calc(100% - 40%);
  }
}
@media (max-width: 768px) {
  .menu-overlay {
    left: 0;
    max-width: 100%;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.menu-panel {
  position: fixed;
  top: 0;
  left: 0;
  width: 32.14%;
  max-width: 486rem;
  height: 100vh;
  background: #ffffff;
  z-index: 10001;
  display: flex;
  flex-direction: column;
  padding: 40rem;
  padding-top: 23rem;
  overflow-y: auto;
  border-right: 1rem solid rgba(0, 0, 0, 1);
}
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.8s cubic-bezier(0.19, 1, 0.22, 1);
}
.slide-enter,
.slide-leave-to {
  transform: translateX(-100%);
}
.drawer-slide-enter-active,
.drawer-slide-leave-active {
  transition: transform 0.8s cubic-bezier(0.19, 1, 0.22, 1);
}
.drawer-slide-enter,
.drawer-slide-leave-to {
  transform: translateX(-100%);
}
.right-content-area {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  width: 32.14%;
  max-width: 486rem;
  background: #000;
  z-index: 10000;
  transition: left 0.6s cubic-bezier(0.19, 1, 0.22, 1), transform 1s cubic-bezier(0.19, 1, 0.22, 1);
  overflow: hidden;
  border-right: 1rem solid rgba(0, 0, 0, 1);
}
.right-content-area.is-collapsed {
  transform: translateX(-200%);
  transition: left 0.6s cubic-bezier(0.19, 1, 0.22, 1), transform 0.3s cubic-bezier(0.42, 0, 1, 1);
}
.right-content-inner {
  width: 100%;
  height: 100%;
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hero-image {
  width: 100%;
  height: 100%;
  max-height: 100%;
  object-fit: cover;
  object-position: center;
  opacity: 0;
  animation: fadeIn 0.8s cubic-bezier(0.19, 1, 0.22, 1) forwards;
}
.hero-title {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #ffffff;
  font-size: 20rem;
  font-weight: 700;
  text-transform: uppercase;
  text-align: center;
  font-family: 'Apercu-Medium', serif;
  width: 100%;
  padding: 0 20rem;
  pointer-events: none;
  white-space: nowrap;
  opacity: 0;
  animation: textSlideIn 0.8s cubic-bezier(0.19, 1, 0.22, 1) forwards;
  animation-delay: 0.1s;
}
@keyframes textSlideIn {
  from {
    opacity: 0;
    transform: translate(-60%, -50%);
  }
  to {
    opacity: 1;
    transform: translate(-50%, -50%);
  }
}
.menu-top-nav {
  display: flex;
  gap: 25rem;
  margin-bottom: 87rem;
}
.menu-nav-link {
  color: rgba(0, 0, 0, 0.3);
  text-decoration: none;
  font-size: 16rem;
  font-weight: 500;
  transition: color 0.3s;
  position: relative;
}
.menu-nav-link:hover {
  color: #000;
}
.menu-nav-link.active {
  color: #000;
  font-weight: 500;
}
.menu-content {
  flex: 1;
  padding-left: 9rem;
}
.menu-section {
  display: flex;
  flex-direction: column;
  gap: 50rem;
}
.category-section {
  display: flex;
  flex-direction: column;
  gap: 20rem;
}
.category-header {
  display: flex;
  align-items: baseline;
  gap: 20rem;
  height: 14rem;
  line-height: 14rem;
}
.category-title {
  font-size: 20rem;
  font-weight: 500;
  color: #000;
  margin: 0;
  text-transform: uppercase;
  font-family: 'Apercu-Medium', sans-serif;
  cursor: pointer;
  transition: opacity 0.2s;
}
.category-title:hover {
  opacity: 0.6;
}
.view-all {
  font-size: 20rem;
  font-weight: 500;
  color: #000;
  text-decoration: none;
  text-transform: uppercase;
  transition: opacity 0.3s;
  margin-left: 80rem;
  font-family: 'Apercu-Medium', sans-serif;
}
.view-all:hover {
  opacity: 0.6;
}
.category-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
}
.category-item {
  font-size: 16rem;
  font-weight: 500;
  height: 19rem;
  color: #333;
  text-decoration: none;
  transition: color 0.3s;
  cursor: pointer;
  font-family: 'Apercu-Medium', sans-serif;
}
.category-item:hover {
  color: #000;
  font-family: 'BespokeSerif-Italic', sans-serif !important;
  font-weight: 400 !important;
}
.info-section {
  display: flex;
  flex-direction: column;
  gap: 20rem;
}
.info-header {
  display: flex;
  align-items: baseline;
  gap: 5rem;
}
.section-title {
  font-size: 20rem;
  font-weight: 500;
  color: #000;
  margin: 0;
  text-transform: uppercase;
  font-family: 'Apercu-Medium', sans-serif;
  height: 14rem;
  line-height: 14rem;
}
.info-list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
}
.info-item {
  font-size: 16rem;
  font-weight: 500;
  color: #333;
  text-decoration: none;
  transition: color 0.3s;
  cursor: pointer;
  font-family: 'Apercu-Medium', sans-serif;
}
.info-item:hover {
  color: #000;
}
.projects-section {
  margin-top: 20rem;
}
.view-all-link {
  font-size: 20rem;
  font-weight: 500;
  color: #000;
  text-decoration: none;
  transition: opacity 0.3s;
  font-family: 'Apercu-Medium', sans-serif;
}
.view-all-link:hover {
  opacity: 0.6;
}
.menu-bottom-links {
  display: flex;
  flex-direction: column;
  margin-top: auto;
  padding-top: 40rem;
  margin-left: 2rem;
  margin-bottom: 4rem;
}
.menu-link {
  color: #333;
  text-decoration: none;
  font-size: 13rem;
  transition: color 0.3s;
  cursor: pointer;
}
.menu-link-bottom {
  color: rgba(0, 0, 0, 1);
  text-decoration: none;
  font-size: 16rem;
  transition: color 0.3s;
  cursor: pointer;
  font-family: 'Apercu-Medium', sans-serif;
}
.menu-link:hover {
  color: #000;
}
@media (max-width: 768px) {
  .menu-panel {
    width: 80%;
    padding: 20rem;
    z-index: 9999;
  }
  .menu-top-nav {
    gap: 15rem;
    margin-bottom: 40rem;
  }
  .right-content-area {
    display: none;
  }
  .hero-title {
    font-size: 32rem;
  }
  .view-all {
    margin-left: 40rem;
  }
}
.menu-top-right-icons {
  position: fixed;
  top: 23rem;
  right: 40rem;
  display: flex;
  gap: 18rem;
  z-index: 10002;
  color: #fff;
}
.icon-btn {
  background: none;
  border: none;
  cursor: pointer;
  color: inherit;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: opacity 0.3s ease;
}
.icon-btn:hover {
  opacity: 0.7;
}
</style>